import { SettingsSection } from '@components'

import { Button } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface StripePortalInvoicesSectionProps {
  isOpeningPortal: boolean
  onViewInvoices: () => void
}

export const StripePortalInvoicesSection = ({
  isOpeningPortal,
  onViewInvoices,
}: StripePortalInvoicesSectionProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <SettingsSection>
      <SettingsSection.RowsContainer>
        <SettingsSection.Content title={t('organization_subscription.invoices')}>
          <Button loading={isOpeningPortal} onClick={onViewInvoices} variant="outlined">
            {t('organization_subscription.stripe_portal.view_invoices_button')}
          </Button>
        </SettingsSection.Content>
      </SettingsSection.RowsContainer>
    </SettingsSection>
  )
}
